export default __webpack_public_path__ + "static/media/starCollect.8c3f8f7a.mp3";